<template>
  <div
    class="row py-3"
    :class="{ 'menu-button': !disabled, 'not-allowed': disabled }"
    @click="!disabled && $emit('click')"
  >
    <div class="col--1">
      <smtt-icon class="align-middle" :icon="icon" />
    </div>
    <div class="col--8 align-middle" :class="{ 'text-muted': disabled }">
      {{ text }}
    </div>
  </div>
</template>

<script>
export default {
  name: "MenuButton",
  props: {
    icon: String,
    text: String,
    disabled: Boolean,
  },
};
</script>

<style scoped>
.menu-button {
  cursor: pointer;
}
.not-allowed {
  cursor: not-allowed;
}
</style>
